import { render, staticRenderFns } from "./CompanyDetailsPage.vue?vue&type=template&id=49450fe0&scoped=true&"
import script from "./CompanyDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailsPage.vue?vue&type=style&index=0&id=49450fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49450fe0",
  null
  
)

export default component.exports